module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-DRIP_BOX.b9936fc7.jpg";